$(document).ready(() => {
    let galleryTag = encodeURIComponent('[GALLERY]');

    $(`a[href="${galleryTag}"]`).each((index, element) => {
        $(element).attr('href', 'javascript:showGallery();');
        $(element).data('fancybox-trigger', 'gallery');
        $(element).addClass('gallery-link');
    });
});

window.showGallery = () => {
    $('a#open-gallery-btn').click();
};